import { snackbar } from '@ifood/pomodoro-components';
import { InfoFilled } from '@ifood/pomodoro-icons';

type PropTypes = {
  message: string;
  autoClose?: boolean;
};

export const notifyError = ({ message, autoClose = true }: PropTypes): void => {
  snackbar({ autoClose, message, variant: 'error', className: 'snackbar-container' });
};

export const notifySuccess = ({ message, autoClose = true }: PropTypes): void => {
  snackbar({ autoClose, message, variant: 'success', className: 'snackbar-container', icon: InfoFilled });
};
